import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import admin from "@/shared/api/admin";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom"
import { Header } from "@/components/SiteUI";
import { TestResultCard } from "@/components/test/TestResultCard";
import tests from "@/shared/api/tests";
import { TestList } from "@/components/test/TestList";

// detailed user info
export const AdminUserPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);


    useEffect(() => {
        const fetchUser = async () => {
            try {
                const res = await admin.getUser(params.id);
                setUser(res.user);
            } catch (err) {
                console.error(err.message);
            }

        }

        fetchUser();
    }, []);

    if (!user) return null;

    const onBack = () => {
        navigate('/admin/users')
    }


    const onSetRole = async (role) => {

        try {
            const res = await admin.setUserRole(params.id, role);
            if (res.message === "User role changed") {
                navigate('/admin/users')
            }
        } catch (err) {
            console.error(err.message);
        }
    }

    return (
        <div>
            <div className="max-w-6xl mx-auto mt-4">
                <div className="bg-card rounded-lg border p-6">
                    <div className="flex items-center justify-between my-2 flex-wrap gap-4">
                        <div className="flex items-start gap-4 flex-wrap">
                            <Button variant="outline" size="sm" onClick={onBack}>
                                <ArrowLeft className="h-4 w-4 mr-1" />
                                Назад
                            </Button>
                            <div className="flex flex-col gap-2">
                                <div className="flex items-center gap-2 flex-wrap">
                                    <h2 className="my-0">Пользователь: {user?.name ?? "—"}</h2>
                                    {user.verified ? <Badge variant="outline">Верифицирован</Badge> : <Badge variant="destructive">Не верифицирован</Badge>}
                                </div>
                                <p className="text-muted-foreground">ID: {params.id}</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-4">
                            <AlertDialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
                                <AlertDialogTrigger asChild>
                                    <Button>
                                        <ShieldCheck className="h-4 w-4 mr-2" />
                                        {user.role === "admin" ? "Удалить права админа" : "Выдать права админа"}
                                    </Button>
                                </AlertDialogTrigger>
                                <AlertDialogContent>
                                    <AlertDialogHeader>
                                        <AlertDialogTitle>Подтверждение действия</AlertDialogTitle>
                                        <AlertDialogDescription>
                                            Вы уверены, что хотите {user.role === "admin" ? "удалить" : "выдать"} права администратора пользователю <strong>{user.name}</strong>?
                                        </AlertDialogDescription>
                                    </AlertDialogHeader>
                                    <AlertDialogFooter>
                                        <AlertDialogCancel>Отмена</AlertDialogCancel>
                                        <AlertDialogAction onClick={() => onSetRole(user.role === "admin" ? "user" : "admin")}>
                                            Подтвердить
                                        </AlertDialogAction>
                                    </AlertDialogFooter>
                                </AlertDialogContent>
                            </AlertDialog>

                        </div>
                    </div>
                    <div className="space-y-4">
                    </div>
                </div>
            </div>

            <TestList className="mt-4 mb-24" user={user._id} />

        </div>
    )
}